import * as React from "react";
import { Profiles } from "./ProfilesPage";

type Props = {};

const ProfilesPage = (props: Props) => {
	return <Profiles />;
};

export default ProfilesPage;
